export default "__VITE_ASSET__nicMJq9w__"